
import React, { Component } from 'react';
import './style.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from '../Button/Button';
import { user_Status} from "Api/Api";
import { origin } from 'utils/Helper';


class PkCreateBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  CreatePk=()=>{
    if (user_Status === 1) {
      localStorage.clear();
      window.location.href = window.location.protocol+'//'+window.location.hostname+'/';
    } else {
      window.location.href = origin; 
    }  }
  
  render() { 
    return (
      <div>
      {/* Banner section starts */}
          <Row style={{ marginRight: 0, marginLeft: 0 }}>
            <section className="pk-create-bg" style={this.props.footerBannerImg}>
              <div className="container">
                <div className="row">
                  <Col sm={12} md={12} lg={8}>
                    <div className="guest-btn">
                    <h1>{this.props.pkCreateFooterHeading}</h1>
                    <div className="footer-banner-btn">
                    {/*
                      <a target="_blank" rel="noopener" href="https://go.pechakucha.com/for-schools">
                      <Button theme="btn-global btn-hover btn-white btn-fit">{this.props.schoolsBtn}</Button>
                      </a>
                      <a target="_blank" rel="noopener" href="https://go.pechakucha.com/for-businesses">
                      <Button theme="btn-global btn-hover btn-white btn-fit">{this.props.businessBtn}</Button>
                      </a>
                    */}
                      <a target="_blank" rel="noopener" href="https://go.pechakucha.com/host-an-event">
                      <Button theme="btn-global btn-hover btn-white btn-fit">{this.props.hostAnEventBtn}</Button>
                      </a>
                    </div>
                    
                    </div>
                  </Col>
                </div>
              </div>
            </section>
          </Row>
        </div>
      // {/* Banner section Ends */}
    );
  }
}


export default PkCreateBanner;
